var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52686 10C5.52686 9.72386 5.75071 9.5 6.02686 9.5H12.8197L10.1733 6.85355C9.97804 6.65829 9.97804 6.34171 10.1733 6.14645C10.3686 5.95118 10.6851 5.95118 10.8804 6.14645L14.3804 9.64645C14.5757 9.84171 14.5757 10.1583 14.3804 10.3536L10.8804 13.8536C10.6851 14.0488 10.3686 14.0488 10.1733 13.8536C9.97804 13.6583 9.97804 13.3417 10.1733 13.1464L12.8197 10.5H6.02686C5.75071 10.5 5.52686 10.2761 5.52686 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShort);
export default __webpack_public_path__ + "static/media/arrow-short.4a08dc8ea2e37d7943a9f1e155b85ce2.svg";
export { ForwardRef as ReactComponent };